export enum InventoryEntryStateEnums {
  open = 1,
  close = 2,
}

export enum InventoryEntryTypeEnums {
  entry = 1,
  transfer = 2,
  subRental = 3,
  devolution = 4
}